export default __webpack_public_path__ + "static/media/Img_inverter_display_units.7193e2ae.svg";